module.exports = __webpack_public_path__ + "static/img/12.e960ecc2.png";